<template>
  <div class="flex flex-wrap gap-3">
    <a
      v-for="(url, platform) in platformLinks"
      :key="platform"
      :href="url"
      :aria-label="`Visit ${platform}`"
      target="_blank"
      rel="noopener noreferrer"
      class="transition-opacity hover:opacity-80"
    >
      <SvgIcon
        :name="platform"
        :aria-label="platform"
      />
    </a>
  </div>
</template>

<script setup lang="ts">
import SvgIcon from '~/components/SvgIcon.vue'

interface Props {
  links: any
}
const props = defineProps<Props>()
const supportedPlatforms = [
  'linkedin',
  'facebook',
  'instagram',
  'twitter',
  'x',
  'youtube',
  'tiktok',
  'pinterest',
  'github',
  'snapchat',
  'wikipedia',
  'careers'
]
const platformLinks = computed(() => {
  const links: Record<string, string> = {}
  if (!props.links) return links
  const linksObj
    = typeof props.links === 'object' && !Array.isArray(props.links)
      ? props.links
      : {}
  for (const platform of supportedPlatforms) {
    const lowercasePlatform = platform.toLowerCase()
    const capitalizedPlatform
      = platform.charAt(0).toUpperCase() + platform.slice(1)
    const url = linksObj[lowercasePlatform] || linksObj[capitalizedPlatform]
    if (url) {
      links[platform] = url
    }
  }
  return links
})
</script>
